import { Grid } from '@mui/joy'
import { ParseKeys } from 'i18next'
import { useTranslation } from 'react-i18next'
import { documentsCodeEnumOptions } from '~/shared/config/constants'
import { Switch } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type DocumentsProps = {
  loading: boolean
}

export function Documents({ loading }: DocumentsProps) {
  const { t } = useTranslation()

  return (
    <Container>
      <ContainerTitle>{t('form.documents')}</ContainerTitle>
      <Grid container spacing={5}>
        {documentsCodeEnumOptions.map((param) => (
          <Grid xs={6} key={param.id}>
            <Switch
              labelI18n={param.label as ParseKeys}
              name={`documents.${param.id}`}
              readOnly
              skeletonShow={loading}
            />
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}
